/**
 * SaleProbabilityBadge — "· Sale 72%" in the call card header.
 *
 * One implementation for both header layouts (tabs mode and the wide card):
 * the colour thresholds and the wording live here, not in two JSX copies.
 * `probability` is the 0..1 value from `analysis.result.summary.saleProbability`;
 * null/undefined renders nothing.
 */

import { useTranslation } from 'react-i18next';

export interface SaleProbabilityBadgeProps {
  /** 0..1. Absent/null => nothing is rendered. */
  probability?: number | null;
}

export function saleProbabilityColorClass(probability: number): string {
  if (probability >= 0.6) return 'text-success';
  if (probability >= 0.3) return 'text-warning';
  return 'text-danger';
}

export function SaleProbabilityBadge({ probability }: SaleProbabilityBadgeProps) {
  const { t } = useTranslation('records');

  if (probability == null) return null;

  return (
    <span className="inline-flex items-center gap-1 mr-2">
      <span className="text-fg-faint">&middot;</span>
      <span className={saleProbabilityColorClass(probability)}>
        {t('records.analysisPanel.salePercent', {
          percent: Math.round(probability * 100),
        })}
      </span>
    </span>
  );
}
